import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=0b2d747c&scoped=true&"
import script from "./message-bubble.vue?vue&type=script&lang=js&"
export * from "./message-bubble.vue?vue&type=script&lang=js&"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=0b2d747c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d747c",
  null
  
)

export default component.exports